<div class="tracking-detail-dialog">
    <!-- Dialog Header -->
    <div class="dialog-header">
        <div class="header-left">
            <div class="order-badge">
                <mat-icon>inventory_2</mat-icon>
            </div>
            <div class="header-info">
                <h2 class="dialog-title">Order Details</h2>
                <span class="order-number">#{{ selectedOrder.reference || selectedOrder.id }}</span>
            </div>
        </div>
        <button class="close-btn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Dialog Content -->
    <div class="dialog-content">
        <!-- Timeline Section -->
        <div class="timeline-section">
            <h3 class="section-title">
                <mat-icon>timeline</mat-icon>
                Shipment Progress
            </h3>

            <div class="timeline">
                <!-- Pick Up Status -->
                <div class="timeline-item" [class.completed]="selectedOrder.trackingStatus.pickUp.completed">
                    <div class="timeline-marker">
                        <div class="marker-dot">
                            <mat-icon *ngIf="selectedOrder.trackingStatus.pickUp.completed">check</mat-icon>
                            <span *ngIf="!selectedOrder.trackingStatus.pickUp.completed">1</span>
                        </div>
                        <div class="marker-line" [class.active]="selectedOrder.trackingStatus.onTheWay.completed"></div>
                    </div>
                    <div class="timeline-content">
                        <div class="timeline-header">
                            <span class="timeline-title">{{ selectedOrder.trackingStatus.pickUp.status }}</span>
                            <span class="timeline-badge" [class.active]="selectedOrder.trackingStatus.pickUp.completed">
                                {{ selectedOrder.trackingStatus.pickUp.completed ? 'Completed' : 'Pending' }}
                            </span>
                        </div>
                        <div class="timeline-location">
                            <mat-icon>location_on</mat-icon>
                            <span>{{ selectedOrder.trackingStatus.pickUp.location }}</span>
                        </div>
                        <div class="timeline-datetime">
                            <mat-icon>schedule</mat-icon>
                            <span>{{ selectedOrder.trackingStatus.pickUp.date }} {{ selectedOrder.trackingStatus.pickUp.time }}</span>
                        </div>
                    </div>
                </div>

                <!-- On The Way Status -->
                <div class="timeline-item" [class.completed]="selectedOrder.trackingStatus.onTheWay.completed">
                    <div class="timeline-marker">
                        <div class="marker-dot">
                            <mat-icon *ngIf="selectedOrder.trackingStatus.onTheWay.completed">check</mat-icon>
                            <span *ngIf="!selectedOrder.trackingStatus.onTheWay.completed">2</span>
                        </div>
                        <div class="marker-line" [class.active]="selectedOrder.trackingStatus.delivered.completed"></div>
                    </div>
                    <div class="timeline-content">
                        <div class="timeline-header">
                            <span class="timeline-title">{{ selectedOrder.trackingStatus.onTheWay.status }}</span>
                            <span class="timeline-badge" [class.active]="selectedOrder.trackingStatus.onTheWay.completed">
                                {{ selectedOrder.trackingStatus.onTheWay.completed ? 'Completed' : 'Pending' }}
                            </span>
                        </div>
                        <div class="timeline-location">
                            <mat-icon>local_shipping</mat-icon>
                            <span>{{ selectedOrder.trackingStatus.onTheWay.location }}</span>
                        </div>
                        <div class="timeline-datetime">
                            <mat-icon>schedule</mat-icon>
                            <span>{{ selectedOrder.trackingStatus.onTheWay.date }} {{ selectedOrder.trackingStatus.onTheWay.time }}</span>
                        </div>
                    </div>
                </div>

                <!-- Delivered Status -->
                <div class="timeline-item last" [class.completed]="selectedOrder.trackingStatus.delivered.completed">
                    <div class="timeline-marker">
                        <div class="marker-dot">
                            <mat-icon *ngIf="selectedOrder.trackingStatus.delivered.completed">check</mat-icon>
                            <span *ngIf="!selectedOrder.trackingStatus.delivered.completed">3</span>
                        </div>
                    </div>
                    <div class="timeline-content">
                        <div class="timeline-header">
                            <span class="timeline-title">{{ selectedOrder.trackingStatus.delivered.status }}</span>
                            <span class="timeline-badge" [class.active]="selectedOrder.trackingStatus.delivered.completed">
                                {{ selectedOrder.trackingStatus.delivered.completed ? 'Completed' : 'Pending' }}
                            </span>
                        </div>
                        <div class="timeline-location">
                            <mat-icon>flag</mat-icon>
                            <span>{{ selectedOrder.trackingStatus.delivered.location }}</span>
                        </div>
                        <div class="timeline-datetime">
                            <mat-icon>schedule</mat-icon>
                            <span>{{ selectedOrder.trackingStatus.delivered.date }} {{ selectedOrder.trackingStatus.delivered.time }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="dialog-actions">
            <button class="btn-secondary" (click)="close()">
                <mat-icon>close</mat-icon>
                Close
            </button>
            <button class="btn-primary" (click)="navigateToGoogleMaps(selectedOrder)">
                <mat-icon>map</mat-icon>
                View on Map
            </button>
        </div>
    </div>
</div>
